import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 font-semibold text-lg whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-download-2-line text-xl text-primary-500"></i>
            </span>
            <span>jm下载指南</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive("/")
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive("/about")
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 flex flex-col gap-1">
          <Link
            to="/"
            className={`px-4 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer ${
              isActive("/") ? "bg-primary-100 text-primary-700" : "text-foreground-700"
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`px-4 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700"
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer ${
              isActive("/about") ? "bg-primary-100 text-primary-700" : "text-foreground-700"
            }`}
          >
            关于我们
          </Link>
        </div>
      )}
    </nav>
  );
}